export default [
  {
    title: 'breadcrumb.rolePermission',
    route: 'list-role-permission',
    icon: 'UnlockIcon',
    resource: 'role-permission',
    action: 'read'
  }
];